<template>
  <div id="TireProducts">
    <div class="container mb-2">
      <div class="row">
        <h1>Tyres</h1>
        <h3 class="ms-1">Choose with Your Needs</h3>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <h3 class="ms-3 mt-3 mb-2">Solid Resilient</h3>
      </div>
      <div class="row row-cols-1 row-cols-md-3 g-4">
        <template v-for="(ct, key) in content0">
          <div :class="{ active: key }" :key="key">
            <div class="col">
              <div class="card h-100">
                <img :src="ct.Tyretype0" class="card-img-top" />
                <div class="card-body">
                  <h5 class="card-title">{{ ct.Tyretypename0 }}</h5>
                  <p class="card-text">{{ ct.Text0 }}</p>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <h3 class="ms-3 mt-3 mb-2">Solid Press-On</h3>
      </div>
      <div class="row row-cols-1 row-cols-md-3 g-4">
        <template v-for="(ct, key) in content1">
          <div :class="{ active: key }" :key="key">
            <div class="col">
              <div class="card h-100">
                <img :src="ct.Tyretype1" class="card-img-top" />
                <div class="card-body">
                  <h5 class="card-title">{{ ct.Tyretypename1 }}</h5>
                  <p class="card-text">{{ ct.Text1 }}</p>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <h3 class="ms-3 mt-3 mb-2">Pneumatic</h3>
      </div>
      <div class="row row-cols-1 row-cols-md-3 g-4">
        <template v-for="(ct, key) in content2">
          <div :class="{ active: key }" :key="key">
            <div class="col">
              <div class="card h-100">
                <img :src="ct.Tyretype2" class="card-img-top" />
                <div class="card-body">
                  <h5 class="card-title">{{ ct.Tyretypename2 }}</h5>
                  <p class="card-text">{{ ct.Text2 }}</p>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <h3 class="ms-3 mt-3 mb-2">Polyurethane</h3>
      </div>
      <div class="row row-cols-1 row-cols-md-3 g-4 mb-3">
        <template v-for="(ct, key) in content3">
          <div :class="{ active: key }" :key="key">
            <div class="col">
              <div class="card h-100">
                <img :src="ct.Tyretype3" class="card-img-top" />
                <div class="card-body">
                  <h5 class="card-title">{{ ct.Tyretypename3 }}</h5>
                  <p class="card-text">{{ ct.Text3 }}</p>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TireProd",

  data: () => ({
    category: [],
    content0: [
      {
        Tyretype0:
          "img/Tyre_Products/Solid_Resilient/Trelleborg_Resilient_EliteXP_1024x575.jpg",
        Tyretypename0: "Trelleborg Elite XP",
        Text0: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi metus.",
      },
      {
        Tyretype0:
          "/img/Tyre_Products/Solid_Resilient/Trelleborg_Resilient_M2_1024x575.jpg",
        Tyretypename0: "Trelleborg M²",
        Text0: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi metus.",
      },
      {
        Tyretype0:
          "/img/Tyre_Products/Solid_Resilient/Trelleborg_Resilient_Orca_1024x575.jpg",
        Tyretypename0: "Orca",
        Text0: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi metus.",
      },
      {
        Tyretype0:
          "/img/Tyre_Products/Solid_Resilient/Trelleborg_Resilient_Ecosolid_1024x575.jpg",
        Tyretypename0: "Ecosolid",
        Text0: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi metus.",
      },
      {
        Tyretype0:
          "/img/Tyre_Products/Solid_Resilient/Trelleborg_Resilient_Mastersolid_1024x575.jpg",
        Tyretypename0: "Mastersolid",
        Text0: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi metus.",
      },
      {
        Tyretype0:
          "/img/Tyre_Products/Solid_Resilient/Trelleborg_Resilient_Premia_1024x575.jpg",
        Tyretypename0: "Premia",
        Text0: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi metus.",
      },
      {
        Tyretype0:
          "/img/Tyre_Products/Solid_Resilient/Trelleborg_Resilient_ProHD_1024x575.jpg",
        Tyretypename0: "ProHD",
        Text0: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi metus.",
      },
      {
        Tyretype0:
          "/img/Tyre_Products/Solid_Resilient/Trelleborg_Resilient_ProTEX_1024x575.jpg",
        Tyretypename0: "ProTEX",
        Text0: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi metus.",
      },
    ],
    content1: [
      {
        Tyretype1:
          "img/Tyre_Products/Solid_Press_On/PS1000_transparent_tires_x2_660x660.png",
        Tyretypename1: "PS1000",
        Text1: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi metus.",
      },
      {
        Tyretype1:
          "img/Tyre_Products/Solid_Press_On/Trelleborg_POS_Traction_1024x575.jpg",
        Tyretypename1: "Trelleborg Press-On",
        Text1: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi metus.",
      },
      {
        Tyretype1:
          "img/Tyre_Products/Solid_Press_On/Trelleborg_POS_Monarch-Traction_1024x575.jpg",
        Tyretypename1: "Monarch Press-On",
        Text1: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi metus.",
      },
      {
        Tyretype1:
          "img/Tyre_Products/Solid_Press_On/Trelleborg_POS_Monogrip_1024x575.jpg",
        Tyretypename1: "Trelleborg Mono-Grip Press-On",
        Text1: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi metus.",
      },
      {
        Tyretype1: "img/Tyre_Products/Solid_Press_On/Trelleborg_POS_ITL-POS-1024x575.jpg",
        Tyretypename1: "ITL POS",
        Text1: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi metus.",
      },
      {
        Tyretype1:
          "img/Tyre_Products/Solid_Press_On/Trelleborg_POS_ITL-Maxmatic-1024x575.jpg",
        Tyretypename1: "ITL Maxmatic Press-On",
        Text1: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi metus.",
      },
      {
        Tyretype1: "img/Tyre_Products/Solid_Press_On/Trelleborg_POS_Orca_1024x575.jpg",
        Tyretypename1: "Orca POS",
        Text1: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi metus.",
      },
      {
        Tyretype1: "img/Tyre_Products/Solid_Press_On/Trelleborg_POS_MPC2_1024x575.jpg",
        Tyretypename1: "MPC2 Press-On",
        Text1: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi metus.",
      },
    ],
    content2: [
      {
        Tyretype2: "img/Tyre_Products/Pneumatic/Trelleborg_Pneumatic_TR900_1024x575.jpg",
        Tyretypename2: "Trelleborg TR-900",
        Text2: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi metus.",
      },
      {
        Tyretype2: "img/Tyre_Products/Pneumatic/Trelleborg_Pneumatic_T900_1024x575.jpg",
        Tyretypename2: "Trelleborg T-900",
        Text2: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi metus.",
      },
      {
        Tyretype2: "img/Tyre_Products/Pneumatic/Trelleborg_Pneumatic_T800_1024x575.jpg",
        Tyretypename2: "T-800",
        Text2: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi metus.",
      },
    ],
    content3: [
      {
        Tyretype3:
          "img/Tyre_Products/Polyurethane/Trelleborg_Polyurethane_Monothane_1024x575.jpg",
        Tyretypename3: "Mono-Thane Press-On",
        Text3: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi metus.",
      },
      {
        Tyretype3:
          "img/Tyre_Products/Polyurethane/Trelleborg_Polyurethane_Permathane-Blue_1024x575.jpg",
        Tyretypename3: "Permathane Press-On",
        Text3: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi metus.",
      },
    ],
  }),
};
</script>
<style></style>
